<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro&display=swap');
#app {
  font-family: 'Avenir';
  text-align: center;
  color: #555;
  background-color:#f8f8f8;
  margin-top: 0px;
}

#top-section {
  background:linear-gradient(80deg, #5751d1, #798bf2);
}
</style>

<script>
export default {
    name: 'App'
}
</script>

